import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vShow as _vShow, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5536ff83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ListaDeUsuarios__Botao" }
const _hoisted_2 = { class: "ListaDeUsuarios__CabecalhoModal" }
const _hoisted_3 = { class: "ListaDeUsuarios__TextoCabecalhoModal" }
const _hoisted_4 = { class: "ListaDeUsuarios__ConteudoModal" }
const _hoisted_5 = { class: "ListaDeUsuarios__TextoMensagemModal" }
const _hoisted_6 = { class: "ListaDeUsuarios__RodapeModal" }

import { computed, onMounted, ref, reactive } from "vue"
  import {
    OTabelaUsuariosInativos,
    OTabelaUsuariosAtivos,
    TUsuarios
  } from "@/components/Usuarios"
  import { LPadrao } from "@/layouts"
  import TabMenu from "primevue/tabmenu"
  import Dialog from "primevue/dialog"
  import PButton from "primevue/button"
  import { OTrilhaDeNavegacao } from "@/components/Gerais"
  import { MenuItem } from "primevue/menuitem"
  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import { useRouter } from "vue-router"
  import {
    ListarUsuarios,
    ParamsUsuario,
  } from "@/repositorios/usuarios/usuarios.modelo"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { estados } from "@/types/api"
  import { usarFoto } from "@/composable/UsarFoto/usarFoto"
  import { DadosModal } from "@/components/Usuarios/index.interface"
  import { UsarLeitorDeDadosPaginados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDadosPaginados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { Erro } from "@/repositorios/erros"
  import { useI18n } from "vue-i18n"

  interface Props {
    teleportarPara?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ListaDeUsuarios',
  props: {
    teleportarPara: null
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const PRIMEIRA_PAGINA_PADRAO = 0

  const home = ref<MenuItem>({
    label: t("usuarios"),
    icon: "pi pi-users",
    to: "/usuarios",
  })

  const indexAtivo = ref(0)
  const breadCrumbItems = ref<MenuItem[]>([])
  const tabMenuItens = [{ label: t("ativos") }, { label: t("inativos") }]
  const usuariosAtivos = ref<ListarUsuarios[]>([])
  const usuariosInativos = ref<ListarUsuarios[]>([])
  const estadoDeCarregamentoUsuariosAtivos = ref<number>(estados.INICIAL)
  const estadoDeCarregamentoUsuariosInativos = ref<number>(estados.INICIAL)

  const usuariosRepositorio = new UsuariosRepositorio()

  const router = useRouter()

  const { onErro, onSucesso } = usarMensagemUsuario()
  const { escritor, resolver } = usarEscritorDeDados()

  const parametrosDaRequisicao = {
    deletado: "igual.false",
    ativo: "igual.false",
    "ordenar-por": ["asc.nome"],
    "por-pagina": "10",
  }

  const leitorUsuariosInativos = reactive(
    new UsarLeitorDeDadosPaginados<ListarUsuarios, ParamsUsuario>(
      usuariosRepositorio.listarUsuarios,
      parametrosDaRequisicao,
    )
  )

  const leitorUsuariosAtivos = reactive(
    new UsarLeitorDeDadosPaginados<ListarUsuarios, ParamsUsuario>(
      usuariosRepositorio.listarUsuarios,
      {
        ...parametrosDaRequisicao,
        ativo: "igual.true"
      }
    )
  )

  const desativarUsuarioEscritor = escritor<{ id: string[] }, string[], undefined>(
    usuariosRepositorio.desativarUsuario,
    [[""], undefined]
  )

  const ativarUsuarioEscritor = escritor<{ id: string[] }, string[], undefined>(
    usuariosRepositorio.ativarUsuario,
    [[""], undefined]
  )

  const informacoesModal = ref<DadosModal>({
    id: "",
    nome: "",
    acao: "",
    legenda: "",
    modalEstaAberto: false,
  })

  const carregandoUsuariosInativos = computed(() => {
    return estadoDeCarregamentoUsuariosInativos.value === estados.PEDENTE
  })
  const carregandoUsuariosAtivos = computed(() => {
    return estadoDeCarregamentoUsuariosAtivos.value === estados.PEDENTE
  })
  const redicionarParaNovoUsuario = () => {
    router.push("/usuarios/novo-usuario")
  }

  const definirCorDoBotao = computed(() => {
    const classesDeCor = {
      ativar: "p-button-success",
      desativar: "p-button-warning"
    }
    const acaoDoModal = informacoesModal.value.acao

    return classesDeCor[acaoDoModal]
  })

  const controlarModaisDeUsuario = ({ id, nome, acao, legenda, modalEstaAberto } :DadosModal) => {
    informacoesModal.value = {
      id,
      nome,
      acao,
      legenda,
      modalEstaAberto,
    }
  }

  const fecharModal = () => {
    informacoesModal.value.modalEstaAberto = false
  }

  const definirAcao = () => {
    const exibirModalDeAtivar = informacoesModal.value.acao === "ativar"
    if (exibirModalDeAtivar) {
      ativarUsuario(informacoesModal.value.id)
    } else {
      desativarUsuario(informacoesModal.value.id)
    }
  }

  const carregarTodosOsUsuarios = async (): Promise<void> => {
    await listarTodosOsUsuarios([
      listarUsuariosInativos(leitorUsuariosInativos.primeiraPagina),
      listarUsuariosAtivos(leitorUsuariosAtivos.primeiraPagina)
    ])
  }

  const listarTodosOsUsuarios = async (requisicoes: Promise<void>[]) => {
    try {
      await Promise.all(requisicoes)
    } catch (error: any) {
      const erro = error as Erro
      onErro({
        resumo: erro.mensagem,
        detalhes: erro.detalhe,
      })
    }
  }

  const desativarUsuario = async (id: string) => {
    desativarUsuarioEscritor.mudarArgumentos([[id], undefined])
    await desativarUsuarioEscritor.executar()

    const darRetornoDeErroProUsuario = () => {
      onErro({
        resumo: t("erroAoDesativarUsuario"),
        detalhes: t("naoFoiPossivelDesativarUsuario"),
      })

      fecharModal()
    }

    const darRetornoDeSucessoProUsuario = async () => {
      onSucesso({
        resumo: t("usuarioDesativadoComSucesso"),
        detalhes: t("encontreNaAbaInativos"),
      })

      fecharModal()

      await carregarTodosOsUsuarios()
    }

    resolver<{ id: string[] }>(desativarUsuarioEscritor.resultado, {
      sucesso: darRetornoDeSucessoProUsuario,
      erro: darRetornoDeErroProUsuario,
    })
  }

  const ativarUsuario = async (id: string) => {
    ativarUsuarioEscritor.mudarArgumentos([[id], undefined])
    await ativarUsuarioEscritor.executar()

    const darRetornoDeErroProUsuario = () => {
      onErro({
        resumo: t("erroAoAtivarUsuario"),
        detalhes: t("naoFoiPossivelAtivarUsuario"),
      })

      fecharModal()
    }

    const darRetornoDeSucessoProUsuario = async () => {
      onSucesso({
        resumo: t("usuarioAtivadoComSucesso"),
        detalhes: t("encontreNaAbaAtivos"),
      })

      fecharModal()

      await carregarTodosOsUsuarios()
    }

    resolver<{ id: string[] }>(ativarUsuarioEscritor.resultado, {
      sucesso: darRetornoDeSucessoProUsuario,
      erro: darRetornoDeErroProUsuario,
    })
  }

  const { obterUrlFotoUsuario } = usarFoto()
  const listarUsuariosAtivos = async (pagina: number, porPagina = 10): Promise<void> => {
    estadoDeCarregamentoUsuariosAtivos.value = estados.PEDENTE
    await leitorUsuariosAtivos.porPagina(porPagina).pagina(pagina).executar()
    const statusDaRequisicao = leitorUsuariosAtivos.resultado.status

    if (statusDaRequisicao === "vazio") {
      usuariosAtivos.value = []
    }

    if (statusDaRequisicao === "sucesso") {
      usuariosAtivos.value = await Promise.all(
        leitorUsuariosAtivos.resultado.dados.map(async (usuario) => {
          if (usuario.urlFotoAvatar) {
            return {
              ...usuario,
              fotoDeAvatar: await obterUrlFotoUsuario(usuario.urlFotoAvatar),
            }
          } else {
            return { ...usuario, fotoDeAvatar: "" }
          }
        })
      )
    }
    estadoDeCarregamentoUsuariosAtivos.value = estados.SUCESSO
  }

  const listarUsuariosInativos = async (pagina: number, porPagina = 10): Promise<void> => {
    estadoDeCarregamentoUsuariosInativos.value = estados.PEDENTE
    await leitorUsuariosInativos.porPagina(porPagina).pagina(pagina).executar()
    const statusDaRequisicao = leitorUsuariosInativos.resultado.status

    if (statusDaRequisicao === "vazio") {
      usuariosInativos.value = []
    }

    if (statusDaRequisicao === "sucesso") {
      usuariosInativos.value = await Promise.all(
        leitorUsuariosInativos.resultado.dados.map(async (usuario) => {
          if (usuario.urlFotoAvatar) {
            return {
              ...usuario,
              fotoDeAvatar: await obterUrlFotoUsuario(usuario.urlFotoAvatar),
            }
          } else {
            return { ...usuario, fotoDeAvatar: "" }
          }
        })
      )
    }
    estadoDeCarregamentoUsuariosInativos.value = estados.SUCESSO
  }

  const paginarUsuariosAtivos = ({
    page,
    rows,
  }: {
    page: number
    rows: number
  }) => {
    listarUsuariosAtivos(page, rows)
  }

  const paginarUsuariosInativos = ({
    page,
    rows,
  }: {
    page: number
    rows: number
  }) => {
    listarUsuariosInativos(page, rows)
  }

  const filtrarUsuariosInativos = async (filtros: Record<string, string>) => {
    leitorUsuariosInativos.incrementarParametros({
      ...filtros,
    })

    leitorUsuariosInativos.primeiraPagina = PRIMEIRA_PAGINA_PADRAO
    await listarUsuariosInativos(
      leitorUsuariosInativos.primeiraPagina,
      leitorUsuariosInativos.itensPorPagina
    )
  }

  const filtrarUsuariosAtivos = async (filtros: Record<string, string>) => {
    leitorUsuariosAtivos.incrementarParametros({
      ...filtros,
    })

    leitorUsuariosAtivos.primeiraPagina = PRIMEIRA_PAGINA_PADRAO
    await listarUsuariosAtivos(
      leitorUsuariosAtivos.primeiraPagina,
      leitorUsuariosAtivos.itensPorPagina
    )
  }

  const aplicarFiltrosEmUsuariosAtivos = async (
    filtros: Record<string, string>
  ) => {
    filtrarUsuariosAtivos(filtros)
  }

  const aplicarFiltrosEmUsuariosInativos = async (
    filtros: Record<string, string>
  ) => {
    filtrarUsuariosInativos(filtros)
  }

  const limparFiltrosDosUsuariosInativos = async (
    filtros: Record<string, string>
  ) => {
    filtrarUsuariosInativos(filtros)
  }

  const limparFiltrosDosUsuariosAtivos = async (
    filtros: Record<string, string>
  ) => {
    filtrarUsuariosAtivos(filtros)
  }

  onMounted(async () => {
    await carregarTodosOsUsuarios()
  })

return (_ctx: any,_cache: any) => {
  const _directive_permissionamento = _resolveDirective("permissionamento")!

  return (_openBlock(), _createBlock(_unref(LPadrao), {
    class: "ListaDeUsuarios",
    "data-testid": "ListaDeUsuarios"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TUsuarios), null, {
        navegacao: _withCtx(() => [
          _createVNode(_unref(OTrilhaDeNavegacao), {
            "inicio-da-trilha": home.value,
            "itens-da-trilha": breadCrumbItems.value
          }, null, 8, ["inicio-da-trilha", "itens-da-trilha"]),
          _createVNode(_unref(TabMenu), {
            activeIndex: indexAtivo.value,
            "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((indexAtivo).value = $event)),
            class: "ListaDeUsuarios__TabMenu",
            "data-testid": "ListaDeUsuarios__TabMenu",
            model: tabMenuItens
          }, null, 8, ["activeIndex"]),
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createVNode(_unref(PButton), {
              onClick: redicionarParaNovoUsuario,
              class: "ListaDeUsuarios__Botao p-button-warning",
              "data-testid": "ListaDeUsuarios__Botao",
              label: _unref(t)('adicionarUsuario')
            }, null, 8, ["label"]), [
              [_directive_permissionamento, { operacao: 'criar' }, "Usuarios"]
            ])
          ])
        ]),
        tabelas: _withCtx(() => [
          _withDirectives(_createVNode(_unref(OTabelaUsuariosAtivos), {
            onExibirModalDesativarUsuario: controlarModaisDeUsuario,
            onFiltrarUsuariosAtivos: aplicarFiltrosEmUsuariosAtivos,
            onLimparFiltros: limparFiltrosDosUsuariosAtivos,
            onPaginarUsuariosAtivos: paginarUsuariosAtivos,
            "carregando-lista": _unref(carregandoUsuariosAtivos),
            "itens-por-pagina": leitorUsuariosAtivos.itensPorPagina,
            "primeira-pagina": leitorUsuariosAtivos.definirPagina(),
            "total-de-resultados": leitorUsuariosAtivos.totalDeResultados,
            "usuarios-ativos": usuariosAtivos.value
          }, null, 8, ["carregando-lista", "itens-por-pagina", "primeira-pagina", "total-de-resultados", "usuarios-ativos"]), [
            [_vShow, indexAtivo.value === 0]
          ]),
          _withDirectives(_createVNode(_unref(OTabelaUsuariosInativos), {
            onExibirModalAtivarUsuario: controlarModaisDeUsuario,
            onFiltrarUsuariosInativos: aplicarFiltrosEmUsuariosInativos,
            onLimparFiltros: limparFiltrosDosUsuariosInativos,
            onPaginarUsuariosInativos: paginarUsuariosInativos,
            "carregando-lista": _unref(carregandoUsuariosInativos),
            "itens-por-pagina": leitorUsuariosInativos.itensPorPagina,
            "primeira-pagina": leitorUsuariosInativos.definirPagina(),
            "total-de-resultados": leitorUsuariosInativos.totalDeResultados,
            "usuarios-inativos": usuariosInativos.value
          }, null, 8, ["carregando-lista", "itens-por-pagina", "primeira-pagina", "total-de-resultados", "usuarios-inativos"]), [
            [_vShow, indexAtivo.value === 1]
          ])
        ]),
        modais: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            visible: informacoesModal.value.modalEstaAberto,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((informacoesModal.value.modalEstaAberto) = $event)),
            "append-to": __props.teleportarPara,
            class: "ListaDeUsuarios__Modal",
            "data-testid": "ListaDeUsuarios__Modal",
            draggable: false,
            style: { backgroundColor: 'white' }
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(informacoesModal.value.acao) + " " + _toDisplayString(_unref(t)('usuario')), 1)
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(PButton), {
                  onClick: fecharModal,
                  class: "ListaDeUsuarios__BotaoModalCancelar p-button-danger p-button-text",
                  label: _unref(t)('cancelar')
                }, null, 8, ["label"]),
                _createVNode(_unref(PButton), {
                  onClick: definirAcao,
                  class: _normalizeClass(`ListaDeUsuarios__BotaoModalAcao ${_unref(definirCorDoBotao)}`),
                  "data-testid": "ListaDeUsuarios__BotaoModalAcao",
                  label: informacoesModal.value.acao
                }, null, 8, ["class", "label"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(informacoesModal.value.legenda), 1)
              ])
            ]),
            _: 1
          }, 8, ["visible", "append-to"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})